import { addDays, isBefore, startOfToday } from 'date-fns';
import { RefObject } from 'react';

export const requiredFieldError = 'This field is required';

export const invalidPostcodeError = 'Invalid postcode';

export const invalidMovingDateError = 'Invalid moving date';
export const invalidMovingDateRangeError =
  'Moving date needs to be in the next 28 days or 28 days in the past';

export const isValidPostcode = (postCode: string) => {
  const regex = /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/;

  return regex.test(postCode);
};

export const isValidMovingDate = (day: string, month: string, year: string) => {
  if (year.length !== 4) {
    return false;
  }

  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);

  if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) {
    return false;
  }

  const date = new Date(yearNum, monthNum - 1, dayNum);

  return (
    date.getFullYear() === yearNum &&
    date.getMonth() === monthNum - 1 &&
    date.getDate() === dayNum
  );
};

export const isMovingDateInAllowedRange = (
  day: string,
  month: string,
  year: string,
) => {
  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);

  if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) {
    return false;
  }

  const date = new Date(yearNum, monthNum - 1, dayNum);
  const now = startOfToday();
  const min = addDays(now, -28);
  const max = addDays(now, 28);

  // Check if date is:
  // 1. In the past (date >= today)
  // 2. Less than 28 days from today (date < max)
  return !isBefore(date, min) && isBefore(date, max);
};
export const scrollToFirstError = (formRef: RefObject<HTMLFormElement>) => {
  requestAnimationFrame(() => {
    formRef.current
      ?.querySelector('[data-error="true"]')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
};
